/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
    NEW_INVOICE: 'New invoice'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Error submitting accumulation',
    CANCEL_ACCUMULATION: 'Error canceling accumulation',
    CANCEL_INVOICE: 'Error canceling invoice',
    COUPON_CANCELED: 'Error canceling coupon',
    COUPON_GENERATED: 'Error creating coupon',
    ERROR: 'Error',
    INVOICE_SUBMITTED: 'Error submitting invoice'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Acc. remuneration',
    ATTACHMENT: 'Attachment',
    CHALLENGE: 'Challenge',
    COUPON: 'Coupon',
    COUPON_CODE: 'Coupon code',
    DECISION: 'Decision',
    MONTH: 'Month',
    OBSERVATIONS: 'Observations',
    REMUNERATION: 'Remuneration',
    STATE: 'Status',
    SUBMISSION_DATE: 'Submission date'
  },
  LABEL: {
    ACCUMULATE: 'Accumulate',
    ACCUMULATED: 'Accumulated',
    ACTIVES: 'Actives',
    ALL: 'All',
    BEGIN_DATE: 'Start date',
    CANCEL: 'Cancel',
    CANCEL_ACCUMULATION: 'Cancel accumulation',
    CANCEL_COUPON: 'Cancel coupon',
    CANCEL_INVOICE: 'Cancel Invoice',
    CLOSE: 'Close',
    CODE: 'Code',
    CONFIRM: 'Confirm',
    CONFIRM_ACCUMULATE: 'Accumulate',
    CONFIRM_COUPON_CREATION: 'Generate coupon',
    CONFIRM_SUBMIT_INVOICE: 'Send',
    COPY_COUPON_CODE: 'Copy coupon code',
    COUPON: 'Coupon',
    COUPON_CODE: 'Coupon code',
    CURRENT_PERIOD: 'Current period',
    DATE: 'Date',
    DESCRIPTION: 'Description',
    END_DATE: 'End date',
    FILTER: 'Filter',
    GENERATE_COUPON: 'Generate coupon',
    GO_TO_DETAILS: 'View products',
    INVOICE: 'Invoice',
    MODEL: 'Model',
    MONEY: 'Money',
    MONTH: 'Month',
    NEW_INVOICE: 'New invoice',
    PAYMENT_METHOD: 'Payment method',
    PENDING_COUNTERPARTS: 'Pending Counterparts',
    PENDING_COUNTERPARTS_MODAL_TITLE: 'There are pending counterparts',
    PENDING_VALUE: 'Pending amount',
    PREVIOUS_PERIOD: 'Previous period',
    REMUNERATION: 'Remuneration',
    SELECTED_PRODUCTS: 'Selected products',
    STATE: 'Status',
    SUBMIT_INVOICE_ATTACHMENT: 'Attachment (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Comment',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Amount',
    WITHOUT_PRODUCTS: 'Without selected products',
    YEAR: 'Year'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Are you sure you want to cancel the accumulation?',
    CANCEL_COUPON: 'Are you sure you and to cancel the {value} coupon?',
    CANCEL_INVOICE: 'Are you sure you want to cancel the invoice submission?',
    CANT_GENERATE_COUPON: 'You can\'t generate this coupon.',
    CANT_SUBMIT_REMUNERATION: 'You can\'t submit this invoice.',
    CONFIRM_SUBMIT_COUPON:
      'You are generating a coupon with a value of {couponValue}. Are you sure you intend to complete this operation?',
    EMPTY_TITLE: 'No data'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Remuneration accumulated',
    CANCEL_ACCUMULATION: 'Accumulation canceled',
    CANCEL_INVOICE: 'Invoice canceled',
    COUPON_CANCELED: 'Coupon canceled',
    COUPON_COPIED: 'Coupon copied to clipboard',
    COUPON_GENERATED: 'Coupon created with {value} code',
    INVOICE_SUBMITTED: 'Invoice submitted',
    SUCCESS: 'Success'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Accumulated remuneration',
    ATTACHMENT: 'Attachment',
    CHALLENGE: 'Challenge',
    COUPON: 'Coupon',
    COUPON_CODE: 'Coupon code',
    DECISION: 'Decision',
    MONTH: 'Month',
    OBSERVATIONS: 'Observations',
    REMUNERATION: 'Remuneration',
    STATE: 'State',
    SUBMISSION_DATE: 'Submission date',
    SWIPE: 'Swipe left to see more columns.',
    VIEW_CHALLENGE_DETAILS: 'View challenge details'
  }
};
